import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase, serverTimestamp } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';

const config = {
  apiKey: "AIzaSyBRL2SVy9BSEAUSJaI41MgvgfkAoTl3GuI",
  authDomain: "virtual-showing.firebaseapp.com",
  databaseURL: "https://virtual-showing.firebaseio.com",
  projectId: "virtual-showing",
  storageBucket: "virtual-showing.appspot.com",
  messagingSenderId: "905707444872",
  appId: "1:905707444872:web:bdb34ae909162e4d131d3d",
  measurementId: "G-ME5FJ22G78"
};

const app = initializeApp(config);

export const auth = getAuth;
export const db = getDatabase(app);
export const ServerValue = { TIMESTAMP: serverTimestamp() };
export const analytics = getAnalytics(app);
